import * as React from 'react';
import ReactDOM from 'react-dom';
import {withRouter} from 'react-router-dom';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

import {TeamAiRoot} from './team-ai-root';

type OwnProps = {
    teamAiMountId: string;
};
type Props = OwnProps & ContextRouter;

class TeamAiPortalledComponent extends React.Component<Props> {
    teamAiMount: HTMLElement | null | undefined;

    constructor(props: Props) {
        super(props);
        this.teamAiMount = document.getElementById(props.teamAiMountId);
        // Remove existing (plachoelder or previously-rendered nut.js) sidebar contents.
        while (this.teamAiMount && this.teamAiMount.firstChild) {
            this.teamAiMount.removeChild(this.teamAiMount.firstChild);
        }
    }

    render() {
        const mount = this.teamAiMount;
        if (!mount) {
            return null;
        }

        return ReactDOM.createPortal(<TeamAiRoot />, mount);
    }
}

// @ts-expect-error
export const TeamAiPortalled = withRouter<OwnProps>(TeamAiPortalledComponent);
